<template>
  <div class="boss-message-heading">
    <div
      class="boss-message-heading-when"
      data-test="date"
    >
      {{ date | formatDate }}
    </div>
    <div
      class="boss-message-heading-title"
      data-test="phase-info"
    >
      選考フェーズを「{{ phaseName }}」に変更しました。
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    phaseName: {
      type: String,
      default: ''
    }
  }
}
</script>
